import type { DayView } from '../api.js';
import { JournalQuote, Loading, MediaStrip, Page, useApi } from '../components.js';
import { href } from '../router.js';

export function DayPage({ exp, day }: { exp: string; day: string }) {
  const { data, error } = useApi<DayView>(`/api/expeditions/${exp}/days/${day}`);
  const back = { href: href.expedition(exp), label: 'Days' };
  if (!data) return <Page title={day} back={back}><Loading error={error} /></Page>;
  return (
    <Page title={`${data.day.id} · ${data.day.title}`} back={back}>
      <p className="muted">{data.day.date}{data.day.routeText ? ` · ${data.day.routeText}` : ''}{data.stay ? <> · night: <a href={href.history(exp, 'place', data.stay.id)}>{data.stay.name}</a></> : null}</p>
      {data.events.map((v) => (
        <section key={v.event.id} className="event">
          <a href={href.event(exp, v.event.id)}><h2>{v.event.title}</h2></a>
          <p className="muted">{v.event.id}{v.event.kind ? ` · ${v.event.kind}` : ''}{v.event.origin !== 'journal' ? ` · ${v.event.origin}` : ''}{v.places.map((p) => <span key={p.id}> · <a href={href.history(exp, 'place', p.id)}>{p.name}</a></span>)}</p>
          {v.journal.map((j) => <JournalQuote key={j.id} j={j} />)}
          <MediaStrip exp={exp} media={v.media} />
        </section>
      ))}
      {!data.events.length && <p className="muted">Nothing recorded for this day yet.</p>}
      {data.unlinkedJournal.length > 0 && <section><h2>Not linked to an event</h2>{data.unlinkedJournal.map((j) => <JournalQuote key={j.id} j={j} />)}</section>}
      {data.unlinkedMedia.length > 0 && <section><h2>Media without an event</h2><MediaStrip exp={exp} media={data.unlinkedMedia} /></section>}
    </Page>
  );
}
